<template>
    <section :class="{'has-title' : title, 'is-light' : isLight}">
        <div class="title" v-if="title">
            {{ title }}
        </div>
        <div class="countdown" v-if="duration" >
            <div :class="[ duration.years ? 'tocome' : 'passed' ]">
                <span class="number">{{ duration.years }}</span>
                <span class="text" v-if="duration.years == 1">Jahr</span>
                <span class="text" v-else>Jahre</span>
            </div>
            <div :class="[ months ? 'tocome' : 'passed' ]">
                <span class="number">{{ months }}</span>
                <span class="text" v-if="months == 1">Monat</span>
                <span class="text" v-else>Monate</span>
            </div>
            <div :class="[ days ? 'tocome' : 'passed' ]">
                <span class="number">{{ days }}</span>
                <span class="text" v-if="days == 1">Tag</span>
                <span class="text" v-else>Tage</span>
            </div>
            <div :class="[ hours ? 'tocome' : 'passed' ]">
                <span class="number">{{ hours }}</span>
                <span class="text" v-if="hours == 1">Stunde</span>
                <span class="text" v-else>Stunden</span>
            </div>
            <div :class="[ minutes ? 'tocome' : 'passed' ]">
                <span class="number">{{ minutes }}</span>
                <span class="text" v-if="minutes == 1">Minute</span>
                <span class="text" v-else>Minuten</span>
            </div>
            <div :class="[ seconds ? 'tocome' : 'passed' ]">
                <span class="number">{{ seconds }}</span>
                <span class="text" v-if="seconds == 1">Sekunde</span>
                <span class="text" v-else>Sekunden</span>
            </div>
        </div>
        <div class="expired" v-else>
            <span>Der Countdown zum</span>
            <span>{{ targetDateFormatted }}</span>
            <span>ist abgelaufen.</span>
        </div>
        <div class="debug">{{ resolution }} | {{ params.datetime }}</div>
    </section>
</template>

<script>
    import { DateTime, Interval } from 'luxon';

    export default {
        name: 'date-time',
        data () {
            return {
                now: DateTime.local(),
                height: 0,
                width: 0,
                defaultBackground: 'rebeccapurple'
            };
        },
        computed: {
            params () {
                return this.$route.params;
            },
            targetDate() {
                if (!this.params.datetime) {
                    return DateTime.local();
                }
                return DateTime.fromISO(this.params.datetime);
            },
            targetDateFormatted() {
                return this.targetDate.toFormat('DDDD tt');
            },
            duration() {
                if (this.now < this.targetDate) {
                    return Interval.fromDateTimes(this.now, this.targetDate).toDuration(['years', 'months', 'days', 'hours', 'minutes', 'seconds']).toObject();
                }
                return false;
            },
            years() {
                return this.duration.years;
            },
            months() {
                if (!this.duration.months && this.duration.years) {
                    return '00';
                }
                return this.zeroFill(this.duration.months);
            },
            days() {
                if (!this.duration.days && (this.duration.years || this.duration.months)) {
                    return '00';
                }
                return this.zeroFill(this.duration.days);
            },
            hours() {
                if (!this.duration.hours && (this.duration.years || this.duration.months || this.duration.days)) {
                    return '00';
                }
                return this.zeroFill(this.duration.hours);
            },
            minutes() {
                if (!this.duration.minutes && (this.duration.years || this.duration.months || this.duration.days || this.duration.hours)) {
                    return '00';
                }
                return this.zeroFill(this.duration.minutes);
            },
            seconds() {
                if (!Math.floor(this.duration.seconds) && (this.duration.years || this.duration.months || this.duration.days || this.duration.hours || this.duration.minutes)) {
                    return '00';
                }
                return this.zeroFill(Math.floor(this.duration.seconds));
            },
            resolution() {
                return this.width + 'x' + this.height;
            },
            bgColor() {
                let color = this.defaultBackground;
                if (this.params.color && this.params.color !== null && this.params.color !== 'null') {
                    color = this.params.color;
                    if (this.params.color.match(/[0-9A-F]{6}/i)) {
                        color = '#' + this.params.color;
                    }
                }
                return color;
            },
            textColor() {
                return this.getContrast50();
            },
            title() {
                return this.params.title;
            },
            isLight() {
                return this.getContrast50() === 'black';
            }
        },
        methods: {
            updateNow () {
                this.now = DateTime.local();
            },
            timer () {
                setInterval(this.updateNow, 100);
            },
            zeroFill(num) {
                if (!num) {
                    return;
                }
                if (num <= 9) {
                    return '0' + num;
                }
                return num;
            },
            setBackground () {
                document.getElementsByTagName('body')[0].style.cssText = `background-color: ${this.bgColor};`;
                this.getBackground();
                if (!this.getBackground()) {
                    document.getElementsByTagName('body')[0].style.cssText = `background-color: ${this.defaultBackground};`;
                }
            },
            getBackground () {
                const computedColor = window.getComputedStyle(document.body, null).getPropertyValue('background-color');
                const styleColor = document.getElementsByTagName('body')[0].style.backgroundColor;
                if (computedColor === 'rgba(0, 0, 0, 0)' || !styleColor) {
                    return false;
                }
                return computedColor;
            },
            setText () {
                document.getElementsByTagName('body')[0].style.color = this.textColor;
            },
            getResolution() {
                this.height = document.body.clientHeight || document.documentElement.clientHeight || document.documentElement.scrollHeight;
                this.width = document.body.clientWidth || document.documentElement.clientWidth || document.documentElement.scrollWidth;
            },
            getContrast50() {
                let color = window.getComputedStyle(document.body, null).getPropertyValue('background-color');
                color = color.match(/rgb\(([\d]*), ([\d]*), ([\d]*)\)/);
                const r = parseInt(color[1]);
                const g = parseInt(color[2]);
                const b = parseInt(color[3]);
                const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                return (yiq >= 128) ? 'black' : 'white';
            }
        },
        created () {
            this.timer();
            document.title = 'countdown bis ' + this.targetDateFormatted;
            this.getResolution();
            window.addEventListener('resize', this.getResolution);
            this.setBackground();
            this.setText();
        }
    };
</script>

<style scoped lang="scss">
    .title {
        height: 1.5rem;
        line-height: 1.5rem;
        font-size: 1rem;
        text-align: center;

        @media (orientation: landscape) {
            position: fixed;
            z-index: 1;
            width: 100%;
            background-color: rgba(black, 0.2);
        }
    }

    .countdown {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        flex-direction: column;

        @media (orientation: landscape) {
            flex-direction: row;
        }

        .has-title & {
            height: calc(100% - 1.5rem);

            @media (orientation: landscape) {
            flex-direction: row;
            height: 100%;
        }
        }
    }

    .countdown > * {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 0 1 100%;
    }

    .countdown .passed {
        transition: flex 0.5s ease;
        flex: 0 0 0;
        overflow: hidden;
    }

    .number {
        font-size: 2em;
        line-height: 1;
        font-family: 'Roboto Mono', monospace;
    }

    .expired {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;

        white-space: nowrap;
    }

    .expired span {
        padding: 0 0.5em;

        &:nth-child(2) {
            background-color: #0054A6;
            color: white;
        }
    }

    .debug {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translatex(-50%);
        display: none;
    }

    // theming
    .countdown > * {
        transition: background-color 0.5s ease;

        &.tocome + .tocome {
            background-color: rgba(white, 0.1);

            .is-light & {
                background-color: rgba(black, 0.05);
            }
        }
        &.tocome + .tocome + .tocome {
            background-color: rgba(white, 0.2);

            .is-light & {
                background-color: rgba(black, 0.1);
            }
        }
        &.tocome + .tocome + .tocome + .tocome {
            background-color: rgba(white, 0.3);

            .is-light & {
                background-color: rgba(black, 0.15);
            }
        }
        &.tocome + .tocome + .tocome + .tocome + .tocome {
            background-color: rgba(white, 0.4);

            .is-light & {
                background-color: rgba(black, 0.2);
            }
        }
        &.tocome + .tocome + .tocome + .tocome + .tocome + .tocome {
            background-color: rgba(white, 0.5);

            .is-light & {
                background-color: rgba(black, 0.25);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// DateTime.vue?2c1fb75a